/* The milestone color picker (Duncan 2026-11-02, his picks: each milestone its own color, 8 quick picks plus any color,
   shown on the diamond and the dot). In General under Task Type when Milestone is ticked (Duncan: "move it up to be a
   part of general"), in Task Properties and Add Task. */
import React from 'react';
import { MILESTONE_COLORS, isHexColor } from '../lib/milestoneColor';

const dot = (selected) => ({
  width: 24, height: 24, padding: 0, borderRadius: 999, cursor: 'pointer', flexShrink: 0, position: 'relative',
  border: selected ? '2px solid var(--text-1)' : '1px solid var(--border-default)',
  boxShadow: selected ? 'inset 0 0 0 2px var(--bg-surface)' : 'none',
});

export default function MilestoneColorPicker({ value, onChange, disabled }) {
  const current = isHexColor(value) ? value.toLowerCase() : null;
  const custom = current && !MILESTONE_COLORS.some((c) => c.value === current);
  return (
    <div style={{ marginBottom: 12, opacity: disabled ? 0.6 : 1 }}>
      <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>Milestone color</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
        {MILESTONE_COLORS.map((c) => (
          <button key={c.label} type="button" title={c.label} aria-label={c.label} aria-pressed={current === c.value}
            disabled={disabled} onClick={() => onChange(c.value)}
            style={{ ...dot(current === c.value), background: c.value || 'var(--type-milestone)' }} />
        ))}
        <label title="Any color" aria-label="Any color"
          style={{ ...dot(custom), display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: custom ? current : 'var(--bg-surface)',
            borderStyle: custom ? 'solid' : 'dashed', cursor: disabled ? 'not-allowed' : 'pointer' }}>
          {!custom && (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--text-3)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
              <path d="M12 21a9 9 0 0 1 0 -18c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828c-.844 .75 -1.989 1.172 -3.182 1.172h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25" />
              <circle cx="7.5" cy="10.5" r=".5" fill="var(--text-3)" /><circle cx="12" cy="7.5" r=".5" fill="var(--text-3)" /><circle cx="16.5" cy="10.5" r=".5" fill="var(--text-3)" />
            </svg>
          )}
          <input type="color" disabled={disabled} value={current || '#b8860b'} onChange={(e) => onChange(e.target.value.toLowerCase())}
            style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0, cursor: 'inherit', border: 0, padding: 0 }} />
        </label>
      </div>
    </div>
  );
}
